module.exports = __webpack_public_path__ + "img/concava.11e79be0.png";